import { Component,
         Output,
         EventEmitter }                   from '@angular/core';
import { TableColumn,
         TableColumnType }                from './../common/table-column';
import { CompanySortableFilter }          from './company-sortable-filter';
import { CompanyService }                 from './../shared/company.service';
import { UploadService }                  from './../shared/upload.service';
import { CompanyDialogComponent }         from './../company-dialog/company-dialog.component';
import { MatDialog }                       from '@angular/material';
import { Observable }                     from 'rxjs/Observable';
import { Globals }                        from './../common/globals';
import { SavingDialogComponent }          from './../common/saving-dialog.component';
import { CompanyModel }                   from './company.model';
import { MatSnackBar }                     from '@angular/material';
import { PortalTypeEnum } from '../login/login.model';
import { retry } from 'rxjs/operator/retry';

@Component({
  selector: 'sa-company-list',
  template: require('./company-list.component.html'),
  styles: [require('./company-list.component.scss')]
})
export class CompanyListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new CompanySortableFilter('companyName');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: CompanyService;

  private businessTypeFunction = (val: any) => {
    let bType = <PortalTypeEnum>val;
    let output = '';
    // tslint:disable-next-line:no-bitwise
    if (bType & PortalTypeEnum.Bus) {
        output += '<div class="logo-bus"></div>';
    }
    // tslint:disable-next-line:no-bitwise
    if (bType & PortalTypeEnum.Train) {
        output += '<div class="logo-train"></div>';
    }
    return output;
  };

  constructor(
    apiService: CompanyService,
    private uploadService: UploadService,
    private dialog: MatDialog,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);
    this.filter.activeOnly = true;

    this.columns = [
      new TableColumn(TableColumnType.Text, 'name', 'Daňový subjekt', 250),
      new TableColumn(TableColumnType.Text, 'businessType', '', 150, null, null, null, null, this.businessTypeFunction),
      new TableColumn(TableColumnType.Text, 'companyName', 'Název firmy', 170),
      new TableColumn(TableColumnType.Text, 'companyLin', 'IČ', 150),
      new TableColumn(TableColumnType.Text, 'companyTin', 'DIČ', 160),
      new TableColumn(TableColumnType.Text, 'countryIso2code', 'Země', 65),
      new TableColumn(TableColumnType.Text, 'currencyIsocode', 'Měna', 65),
      new TableColumn(TableColumnType.Text, 'languageIsocode', 'Jaz. dokl.', 65),
      new TableColumn(TableColumnType.Text, 'internalSlotId', 'Slot', 65),
      // new TableColumn(TableColumnType.Text, 'certEet', 'EET cert.', 60),
      new TableColumn(TableColumnType.Bool, 'eetActive', 'EET Aktivní', 100),
      new TableColumn(TableColumnType.Text, 'street', 'Ulice', 150),
      new TableColumn(TableColumnType.Text, 'houseNumber', 'Č. domu', 110),
      new TableColumn(TableColumnType.Text, 'city', 'Město', 150),
      new TableColumn(TableColumnType.Text, 'zipCode', 'PSČ', 110),

      // new TableColumn(TableColumnType.Text, 'line1Top', 'Hlavička 1', 150),
      // new TableColumn(TableColumnType.Text, 'line2Top', 'Hlavička 2', 150),
      // new TableColumn(TableColumnType.Text, 'line3Top', 'Hlavička 3', 150),
      // new TableColumn(TableColumnType.Text, 'line4Top', 'Hlavička 4', 150),
      // new TableColumn(TableColumnType.Text, 'line5Top', 'Hlavička 5', 150),
      // new TableColumn(TableColumnType.Text, 'line1Bottom', 'Patička 1', 150),
      // new TableColumn(TableColumnType.Text, 'line2Bottom', 'Patička 2', 150),
      // new TableColumn(TableColumnType.Text, 'line3Bottom', 'Patička 3', 150),
      // new TableColumn(TableColumnType.Text, 'line4Bottom', 'Patička 4', 150),
      // new TableColumn(TableColumnType.Text, 'line5Bottom', 'Patička 5', 150),
      new TableColumn(TableColumnType.Bool, 'active', 'Aktivní', 100)
    ];
  }

  private getData(filter: CompanySortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(CompanyDialogComponent);
    dialogRef.componentInstance.model = new CompanyModel();
    dialogRef.componentInstance.newItem = true;
    let snack = this.snackbar;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(
            res => {
                cloakRef.close();
                this.search();
                snack.open('Úspěšně uloženo.', '', {duration: 2000});
            },
            error => {
                snack.open('Při ukládání obrázku se vyskytla chyba.', 'Zavřít');
            });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: CompanyModel) {
    let dialogRef = this.dialog.open(CompanyDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;

    dialogRef.afterClosed().subscribe(result => {
      let snack = this.snackbar;

      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        let pendingRequests = [];

        let newImage = dialogRef.componentInstance.model.newImage;
        if (newImage!!) {
            let imgRequest = this.uploadService.makeFileRequest('/api/company/uploadimage/' + model.companyUid, [], [newImage]);
            pendingRequests.push(imgRequest);
            imgRequest.subscribe(
              res => {
                  snack.open('Obrázek uložen.', '', {duration: 2000});
              },
              error => {
                  snack.open('Při ukládání obrázku se vyskytla chyba.', 'Zavřít');
              });
        }

        let newCert = dialogRef.componentInstance.model.newCert;
        if (newCert!!) {
          let certRequest = this.uploadService.makeFileRequest(
              '/api/company/uploadcert/' + model.companyUid + '?password=' + model.eetPassword, [], [newCert]);
          pendingRequests.push(certRequest);
          certRequest.subscribe(
            res => {
                snack.open('Certifikát uložen.', '', {duration: 2000});
            },
            error => {
                snack.open('Při ukládání certifikátu se vyskytla chyba.', 'Zavřít');
            });
        }

        let updateCompanyFn = () => {
          this.apiService.updateItem(dialogRef.componentInstance.model.companyUid, dialogRef.componentInstance.model)
              .subscribe( res => {
                  snack.open('Daňový subjekt uložen.', '', {duration: 3000});
                },
                error => {
                    snack.open('Při ukládání daňového subjektu se vyskytla chyba.', 'Zavřít');
                },
                () => {
                  cloakRef.close();
                });
          };

        // Save anything else after image/cert upload due to a slot migration task
        if (pendingRequests.length > 0) {
          Observable.forkJoin(pendingRequests).subscribe(res => updateCompanyFn());
        } else {
          updateCompanyFn();
        }
      } else {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/company-list/company-list.component.ts